module.exports = __webpack_public_path__ + "static/media/NI.01fc5549.svg";